import { mapByProperty } from '../utils/collection.utils';
import { ToolSettingMode } from './tool-setting-mode';

export class ToolSetting {
  private readonly settingModesByMode: { [modeName: string]: ToolSettingMode };

  constructor(
    public toolHash: string,
    public refrigerationHash: string,
    public breakCheck: boolean,
    public modes: ToolSettingMode[]
  ) {
    this.settingModesByMode = mapByProperty('modeName', this.modes);
  }

  getVibrationByMode(modeName: string) {
    const settingMode = this.getSettingMode(modeName);

    return (settingMode) ? settingMode.vibration : null;
  }

  getPowerByMode(modeName: string) {
    const settingMode = this.getSettingMode(modeName);

    return (settingMode) ? settingMode.power : null;
  }

  private getSettingMode(modeName: string) {
    return this.settingModesByMode[modeName] || null;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/tool-setting.ts